import React, {Component,useState} from 'react'
import {Modal, Avatar, Tooltip, message,Popover,Button,Form,Input,Select,Upload} from 'antd';
import {Redirect, Route, Switch, withRouter,useRouteMatch,useLocation} from 'react-router-dom'
import {envHttpUrl, getmd5} from '../../http/globalMethod'
import {getFeedbackDicList, saveFeedbackData, saveCollectData, loginOutRequest} from '../../request'
import './index.less'
import * as Icon from "@ant-design/icons";
import IconFun from '../../public/icon'

class PortalActions extends Component {
    formRef = React.createRef()
    formCollectRef = React.createRef()
    state = {
        suggestModal:false,
        collectModal:false,
        feedbackType:[],
        severityType:[],
        formParam:{
            id:'',
            pagePath:window.location.href,
            pageTitle:'AMS系统',
            status:1,
            replyComment:'',
            imageList:''
        },
        formCollectParam:{
            id:'',
            pagePath:window.location.href,
            pageTitle:'AMS系统',
        },
        form:null
    }
    handleOpenModal = ()=>{
        this.setState({
            suggestModal:true
        })
        getFeedbackDicList().then(res=>{
            this.setState({
                feedbackType:res.feedbackType,
                severityType:res.severityType,
            })
        })


    }
    handleOpenCollectModal = ()=>{
        this.setState({
            collectModal:true
        })

    }
    handleCloseModal = ()=>{
        console.log(this.formRef)
        this.formRef.current.resetFields()
        this.formCollectRef.current.resetFields()
        this.setState({
            suggestModal:false,
            collectModal:false,
        })

    }
    handleSubmitSuggest = (val)=>{
        console.log(val,this.state.formParam)
        let param = {
            ...this.state.formParam,
            ...val
        }
        saveFeedbackData(param).then(res=>{

        })
        this.handleCloseModal()

    }
    handleSubmitCollect = (val)=>{
        console.log(val,this.state.formCollectParam)
        let param = this.state.formCollectParam
        param.pageTitle = val.pageTitle||'AMS首页'
        saveCollectData(param).then(res=>{

        })
        this.handleCloseModal()

    }

    componentDidMount(){
        console.log('current', this.props);
        this.props.history.listen((location,action,c)=>{
            console.log('location:', location);
            console.log('action:', action);
        })
    }
    render() {
        const {suggestModal,collectModal,formCollectParam} = this.state

        return (
            <>
                <div className="portal-actions">
                    <div className="portal-actions-wrap">
                        <Tooltip placement="left" title="收藏页面">
                            <Avatar onClick={ ()=>this.handleOpenCollectModal()} className="actions-icon" size={34} icon={<Icon.StarOutlined />} />
                        </Tooltip>
                        <Tooltip placement="left" title="反馈及建议">
                            <Avatar onClick={ ()=>this.handleOpenModal()} className="actions-icon" size={34} icon={<Icon.CommentOutlined />} />
                        </Tooltip>

                    </div>
                </div>
                <Modal destroyOnClose forceRender title="反馈及建议" open={suggestModal} footer={false} onCancel={this.handleCloseModal}>
                    <Form
                        ref={this.formRef}
                        labelCol={{ span: 4 }}
                        wrapperCol={{ span: 14 }}
                        layout="horizontal"
                        onFinish={this.handleSubmitSuggest}
                    >
                        <Form.Item label="标题" name="feedbackTitle">
                            <Input placeholder="标题"/>
                        </Form.Item>
                        <Form.Item label="内容" name="feedbackDescription">
                            <Input.TextArea placeholder="详细描述内容"/>
                        </Form.Item>
                        <Form.Item label="反馈类型" name="feedbackType">
                            <Select
                                allowClear
                                style={{minWidth: '200px'}}
                                showSearch
                                placeholder="反馈类型"
                                fieldNames={{label: 'name', value: 'value'}}
                                filterOption={(input, option) =>
                                    (option?.name ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                options={this.state.feedbackType}
                            />
                        </Form.Item>
                        <Form.Item label="反馈等级" name="severity">
                            <Select
                                allowClear
                                style={{minWidth: '200px'}}
                                showSearch
                                placeholder="反馈等级"
                                fieldNames={{label: 'name', value: 'value'}}
                                filterOption={(input, option) =>
                                    (option?.name ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                options={this.state.severityType}
                            />
                        </Form.Item>
                        {/*<Form.Item label="上传" valuePropName="fileList">*/}
                        {/*    <Upload action="/upload.do" listType="picture-card">*/}
                        {/*        <div>*/}
                        {/*            <Icon.PlusOutlined />*/}
                        {/*            <div style={{ marginTop: 8 }}>上传图片/视频</div>*/}
                        {/*        </div>*/}
                        {/*    </Upload>*/}
                        {/*</Form.Item>*/}
                        <div style={{display:'flex',justifyContent:'flex-end',alignItems:'center'}}>
                            <Button type="primary" htmlType="submit">
                                提交
                            </Button>
                        </div>
                    </Form>
                </Modal>

                <Modal destroyOnClose forceRender title="页面收藏" open={collectModal} footer={false} onCancel={this.handleCloseModal}>
                    <Form
                        ref={this.formCollectRef}
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 14 }}
                        layout="horizontal"
                        onFinish={this.handleSubmitCollect}
                    >
                        <Form.Item label="自定义收藏标题" name="pageTitle">
                            <Input placeholder="自定义收藏标题"/>
                        </Form.Item>
                        <div style={{display:'flex',justifyContent:'flex-end',alignItems:'center'}}>
                            <Button type="primary" htmlType="submit">
                                提交
                            </Button>
                        </div>
                    </Form>
                </Modal>
            </>


        )
    }
}
export default withRouter(PortalActions)
